import type { NewsItem } from "@/types";

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "《沙漠孤星》点映口碑爆棚，科幻外壳下的情感内核获赞",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20an%20astronaut%20helmet%20reflecting%20an%20orange%20desert%20planet%20horizon%20against%20deep%20blue%20space%2C%20dramatic%20sci-fi%20lighting%2C%20high%20detail%20magazine%20feature%20photography&width=1200&height=675&seq=ya-news-cover-01&orientation=landscape",
    date: "2025-09-28",
    source: "亚洲天堂影视观察",
    summary:
      "《沙漠孤星》首轮点映结束，观众普遍认为影片在宏大科幻设定之外，对孤独与信念的刻画更加打动人心。",
    content: [
      "由陈牧之执导的科幻剧情片《沙漠孤星》于上周末完成了首轮全国点映，映后口碑持续走高。不少观众表示，影片最动人的并非视觉奇观，而是主角在绝境中那份近乎固执的坚持。",
      "影片讲述一名星际勘测员被困在资源枯竭的沙漠行星上，依靠有限补给与一段跨越光年的通讯，完成自我救赎的故事。导演陈牧之在映后交流中提到，他希望用最简的场景，讲一个关于‘人如何与自己相处’的故事。",
      "从影像表达上看，《沙漠孤星》大量运用深蓝与暖橙的对比色调，冷峻的宇宙与温暖的回忆形成鲜明反差，成为影迷讨论的焦点。摄影指导透露，团队为还原沙粒质感，采用了大量实景搭建与自然光拍摄。",
      "据悉，影片正式上映后还将推出幕后纪录片，揭秘沙漠实景拍摄的艰辛过程。想要了解更多主创访谈与深度解析，请持续关注亚洲天堂的后续报道。",
    ],
    tags: ["科幻", "点映", "口碑"],
    relatedWorkId: "m1",
  },
  {
    id: "n2",
    title: "《长安十二辰》完结收官，古装悬疑再树标杆",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20traditional%20chinese%20lantern%20lit%20night%20street%20with%20warm%20orange%20glow%20and%20deep%20blue%20sky%2C%20elegant%20historical%20atmosphere%2C%20high%20detail%20cinematic%20image&width=1200&height=675&seq=ya-news-cover-02&orientation=landscape",
    date: "2025-09-20",
    source: "剧集前线",
    summary:
      "随最后两集播出，《长安十二辰》以高完成度收官，紧凑的时间线与考究的服化道被观众称为‘年度古装悬疑之光’。",
    content: [
      "历时一个多月的播出，《长安十二辰》昨晚迎来大结局。剧集以‘十二个时辰’为叙事框架，将悬疑、历史与群像刻画融为一体，播出期间讨论度居高不下。",
      "该剧对长安城的还原令人印象深刻，从市井街巷到宫阙楼台，细节考究。主创团队表示，为了营造‘烟火气’，大量夜景使用了灯笼与烛光作为主光源，营造出暖橙色的历史质感。",
      "在人物塑造上，守城小吏与天才少女的组合既有张力又不失温情，‘守护万家灯火’的主题也让不少观众直呼‘后劲太大’。",
      "随着剧集收官，关于第二季的讨论也在持续升温。有消息称主创团队已进入新项目筹备阶段，亚洲天堂将持续跟进相关动态。",
    ],
    tags: ["古装", "悬疑", "收官"],
    relatedWorkId: "t1",
  },
  {
    id: "n3",
    title: "《长夜将尽》发布终极预告，犯罪悬疑张力拉满",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20image%20of%20a%20rainy%20neon%20lit%20city%20alley%20at%20night%20with%20warm%20orange%20reflections%20and%20deep%20blue%20shadows%2C%20crime%20thriller%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-news-cover-03&orientation=landscape",
    date: "2025-09-12",
    source: "亚洲天堂影视观察",
    summary:
      "犯罪悬疑片《长夜将尽》发布终极预告，雨夜、旧案与背叛的线索交织，被影迷称为‘年度最期待的华语犯罪片’。",
    content: [
      "《长夜将尽》日前发布终极预告，短短两分钟的画面里，雨夜的城市、泛黄的卷宗与一句‘有些真相，等到天亮才敢说出口’，瞬间点燃影迷期待。",
      "影片聚焦一桩尘封十年的旧案，刑警老周发现线索竟指向自己最信任的搭档。导演周砚青表示，影片想探讨的并非‘谁是真凶’，而是‘真相与情义之间该如何选择’。",
      "从预告质感来看，影片延续了冷峻的蓝调影像，同时用暖橙色灯光点缀关键情绪节点，形成了强烈的视觉张力。",
      "影片将于九月正式公映，点映场次已经陆续开放。更多映前资讯与主创动态，敬请关注亚洲天堂。",
    ],
    tags: ["犯罪", "悬疑", "预告"],
    relatedWorkId: "m2",
  },
  {
    id: "n4",
    title: "《医心仁术》第二季开播，急诊群像再掀热议",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20bright%20modern%20hospital%20corridor%20with%20warm%20light%20and%20deep%20blue%20accents%2C%20clean%20hopeful%20medical%20atmosphere%2C%20high%20detail%20photography&width=1200&height=675&seq=ya-news-cover-04&orientation=landscape",
    date: "2025-09-05",
    source: "剧集前线",
    summary:
      "《医心仁术》第二季开播即登顶热度榜，急诊科的高压日常与医患温情再度引发观众共鸣。",
    content: [
      "备受期待的医疗职场剧《医心仁术》第二季本周正式开播，首播两集便冲上多平台热度榜前列，相关话题讨论量持续攀升。",
      "本季延续了第一季对急诊科日常的写实刻画，同时加入更多年轻医生的成长线。剧集试图在紧张的抢救节奏中，捕捉医患之间那些不易察觉的温柔瞬间。",
      "观众普遍认为，剧集没有回避医疗行业的现实困境，却在困境中保留了希望的光亮，这正是它最动人的地方。",
      "该剧每周更新，亚洲天堂将持续跟进剧情解析与演员访谈。",
    ],
    tags: ["医疗", "职场", "开播"],
    relatedWorkId: "t2",
  },
  {
    id: "n5",
    title: "暑期档观察：类型片百花齐放，现实题材强势崛起",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20row%20of%20cinema%20seats%20lit%20by%20warm%20orange%20projector%20light%20and%20deep%20blue%20ambient%20glow%2C%20movie%20industry%20atmosphere%2C%20high%20detail%20photography&width=1200&height=675&seq=ya-news-cover-05&orientation=landscape",
    date: "2025-08-30",
    source: "亚洲天堂影视观察",
    summary:
      "回顾整个暑期档，科幻、悬疑、家庭等类型片各有斩获，现实题材作品的口碑表现尤为亮眼。",
    content: [
      "随着暑期尾声临近，今年的电影市场交出了一份颇具看点的成绩单。科幻、悬疑、动作等商业类型片依旧是票房主力，但真正引发长线讨论的，却是一批扎根现实的剧情作品。",
      "有分析指出，观众对‘好看’的定义正在发生变化——除了视听刺激，人们越来越愿意为真诚的情感与现实关怀买单。",
      "在多部现实题材作品中，家庭与乡土题材表现突出，它们以细腻的笔触描摹普通人的生活，收获了口碑与票房的双重认可。",
      "接下来秋季档还有多部重磅作品蓄势待发，亚洲天堂将持续为您追踪档期动态与深度评论。",
    ],
    tags: ["档期", "观察", "市场"],
  },
  {
    id: "n6",
    title: "《山海异闻录》特效特辑曝光，异兽设计灵感源自古籍",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20an%20ancient%20chinese%20scroll%20with%20glowing%20mythical%20creature%20illustrations%20and%20warm%20orange%20light%20against%20deep%20blue%20background%2C%20mystical%20fantasy%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-news-cover-06&orientation=landscape",
    date: "2025-08-18",
    source: "幕后工厂",
    summary:
      "《山海异闻录》发布特效制作特辑，主创团队首次公开异兽设计的考据过程与视觉灵感来源。",
    content: [
      "奇幻冒险电影《山海异闻录》近日发布特效制作特辑，向观众揭秘片中异兽从古籍考据到银幕呈现的完整过程。",
      "视效团队表示，片中每一种异兽的形态都参考了《山海经》等古籍描述，并结合现代生物学进行合理化设计，力求在‘神话感’与‘可信度’之间取得平衡。",
      "特辑中，团队还展示了大量概念设计稿与动态测试片段，展现了从传统水墨意境到数字特效的转化过程。",
      "影片正在热映中，更多幕后花絮与深度解读请关注亚洲天堂。",
    ],
    tags: ["奇幻", "特效", "幕后"],
    relatedWorkId: "m4",
  },
  {
    id: "n7",
    title: "迷影手记：为什么我们仍然需要走进电影院",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20image%20of%20an%20empty%20vintage%20cinema%20hall%20with%20a%20glowing%20orange%20screen%20and%20deep%20blue%20seating%2C%20nostalgic%20contemplative%20mood%2C%20high%20detail%20photography&width=1200&height=675&seq=ya-news-cover-07&orientation=landscape",
    date: "2025-08-02",
    source: "亚洲天堂编辑手记",
    summary:
      "在流媒体高度发达的今天，电影院的仪式感与集体观影体验，依然是不可替代的独特存在。",
    content: [
      "在客厅就能看完一部电影的时代，我们为什么还要走进影院？这或许是每一位影迷都思考过的问题。",
      "影院提供的不仅是更大的银幕与更好的音效，更是一种‘共同在场’的体验——陌生人因为同一束光、同一个故事而短暂地心灵相通。",
      "当灯光熄灭、银幕亮起，我们放下手机与日常琐事，把自己交给一段两个小时的旅程。这种专注本身，已经成为一种奢侈。",
      "也许答案很简单：因为好故事值得被郑重地讲述，也值得被郑重地观看。",
    ],
    tags: ["影迷", "随笔", "观影"],
  },
  {
    id: "n8",
    title: "《时光信箱》上线流媒体，寒夜里的一封温暖来信",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20image%20of%20an%20old%20vintage%20mailbox%20glowing%20with%20orange%20light%20on%20a%20snowy%20deep%20blue%20evening%20street%2C%20cozy%20magical%20winter%20atmosphere%2C%20high%20detail%20photography&width=1200&height=675&seq=ya-news-cover-08&orientation=landscape",
    date: "2025-07-22",
    source: "上线速递",
    summary:
      "治愈系爱情奇幻片《时光信箱》正式上线流媒体平台，让错过的观众有机会补上这份迟到的温柔。",
    content: [
      "曾在冬季档收获良好口碑的《时光信箱》今日正式登陆主流流媒体平台，不少此前错过院线的观众表示‘终于等到了’。",
      "影片讲述一个能寄信到过去的老信箱，让女主角与十年前的自己通信，在改写遗憾的过程中重新理解爱与被爱。",
      "凭借细腻的情感刻画与温暖治愈的色调，影片被不少观众列为‘冬夜必看’清单。有评论称，它像一封迟到的信，读完让人久久平静。",
      "喜欢治愈系故事的朋友不妨在安静的夜晚点开它，或许会有意想不到的共鸣。",
    ],
    tags: ["爱情", "治愈", "上线"],
    relatedWorkId: "m8",
  },
];